var noop = require("./util/noop");

module.exports = function(request) {
  if (request && request.readyState < 4) {
    request.onreadystatechange = noop;
    request.abort();
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/pjax/lib/abort-request.js
// module id = 44
// module chunks = 0